import type { PropsWithChildren } from 'react';
import useObservable from 'react-use/lib/useObservable';
import { appThemeApiRef, useApi } from '@backstage/core-plugin-api';
import { type UnifiedTheme, UnifiedThemeProvider } from '@backstage/theme';
import { auraLightTheme } from './auraLight';
import { auraDarkTheme } from './auraDark';
import { auraTritanopiaTheme } from './auraTritanopia';
import { auraMatrixTheme } from './auraMatrix';

type ThemeConfig = { theme: UnifiedTheme; themeName?: string };

const themeConfigById: Record<string, ThemeConfig> = {
  'aura-light': { theme: auraLightTheme },
  'aura-dark': { theme: auraDarkTheme },
  'aura-tritanopia': {
    theme: auraTritanopiaTheme,
    themeName: 'aura-tritanopia',
  },
  'aura-matrix': { theme: auraMatrixTheme, themeName: 'aura-matrix' },
};

export function SharedThemeProvider({ children }: PropsWithChildren<{}>) {
  const appThemeApi = useApi(appThemeApiRef);
  const themeId = useObservable(
    appThemeApi.activeThemeId$(),
    appThemeApi.getActiveThemeId(),
  );
  const config =
    themeConfigById[themeId ?? ''] ?? themeConfigById['aura-light'];
  return (
    <UnifiedThemeProvider theme={config.theme} themeName={config.themeName}>
      {children}
    </UnifiedThemeProvider>
  );
}
